import React from 'react';

export default function GasFiredBoiler1Icon({
  width = 64,
  height = 100,
  startColor = '#3E5A83',
  midColor = '#A6BAD9',
  endColor = '#3E5A83'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 72.029 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_Drain">
	<path d="M0.073,76.54h4.174v4.509H0.073V76.54z" />
</g>
<g id="Group_Supply">
	<path fill="#666666" d="M0.073,69.776h4.174v4.509H0.073V69.776z" />
</g>
<g id="Group_Base">
	<path d="M9.017,106.86h2.142v5.638H9.017V106.86z" />
	<path d="M63.011,106.86h2.254v5.638h-2.254V106.86z" />
</g>
<g id="Group_BoilerBody">
	<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="2.2546" y1="53.9951" x2="72.0291" y2="53.9951">
		<stop offset="0" style={{stopColor: "#3E5A83"}} />
		<stop offset="0.02" style={{stopColor: "#4C678E"}} />
		<stop offset="0.06" style={{stopColor: "#6880A5"}} />
		<stop offset="0.11" style={{stopColor: "#7F96B8"}} />
		<stop offset="0.17" style={{stopColor: "#90A6C7"}} />
		<stop offset="0.23" style={{stopColor: "#9DB1D1"}} />
		<stop offset="0.32" style={{stopColor: "#A4B8D7"}} />
		<stop offset="0.54" style={{stopColor: "#A6BAD9"}} />
		<stop offset="0.66" style={{stopColor: "#A3B7D7"}} />
		<stop offset="0.74" style={{stopColor: "#99AECF"}} />
		<stop offset="0.82" style={{stopColor: "#89A0C1"}} />
		<stop offset="0.89" style={{stopColor: "#738BAE"}} />
		<stop offset="0.96" style={{stopColor: "#567096"}} />
		<stop offset="1" style={{stopColor: "#3E5A83"}} />
	</linearGradient>
	<path fill={`url(#${id}_1_)`} d="M2.255,0.002h69.774v107.986H2.255V0.002z" />
	<path fill="#6D6E71" d="M4.509,6.766h65.266v4.396H4.509V6.766z" />
	<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="4.5085" y1="3.3838" x2="69.7742" y2="3.3838">
		<stop offset="0" style={{stopColor: "#3E5A83"}} />
		<stop offset="0.02" style={{stopColor: "#4C678E"}} />
		<stop offset="0.06" style={{stopColor: "#6880A5"}} />
		<stop offset="0.11" style={{stopColor: "#7F96B8"}} />
		<stop offset="0.17" style={{stopColor: "#90A6C7"}} />
		<stop offset="0.23" style={{stopColor: "#9DB1D1"}} />
		<stop offset="0.32" style={{stopColor: "#A4B8D7"}} />
		<stop offset="0.54" style={{stopColor: "#A6BAD9"}} />
		<stop offset="0.66" style={{stopColor: "#A3B7D7"}} />
		<stop offset="0.74" style={{stopColor: "#99AECF"}} />
		<stop offset="0.82" style={{stopColor: "#89A0C1"}} />
		<stop offset="0.89" style={{stopColor: "#738BAE"}} />
		<stop offset="0.96" style={{stopColor: "#567096"}} />
		<stop offset="1" style={{stopColor: "#3E5A83"}} />
	</linearGradient>
	<path fill={`url(#${id}_2_)`} stroke="#808080" strokeWidth="0.5" strokeMiterlimit="10" d="M4.509,0.002h65.266v6.764H4.509V0.002   z" />
	<path fill="#194CB2" d="M4.509,0.002" />
	<path fill="#194CB2" d="M4.509,96.83" />
	<path fill="none" d="M2.255,0.002h69.774v107.986H2.255V0.002" />
	<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="4.5085" y1="101.2822" x2="69.7742" y2="101.2822">
		<stop offset="0" style={{stopColor: "#3E5A83"}} />
		<stop offset="0.02" style={{stopColor: "#4C678E"}} />
		<stop offset="0.06" style={{stopColor: "#6880A5"}} />
		<stop offset="0.11" style={{stopColor: "#7F96B8"}} />
		<stop offset="0.17" style={{stopColor: "#90A6C7"}} />
		<stop offset="0.23" style={{stopColor: "#9DB1D1"}} />
		<stop offset="0.32" style={{stopColor: "#A4B8D7"}} />
		<stop offset="0.54" style={{stopColor: "#A6BAD9"}} />
		<stop offset="0.66" style={{stopColor: "#A3B7D7"}} />
		<stop offset="0.74" style={{stopColor: "#99AECF"}} />
		<stop offset="0.82" style={{stopColor: "#89A0C1"}} />
		<stop offset="0.89" style={{stopColor: "#738BAE"}} />
		<stop offset="0.96" style={{stopColor: "#567096"}} />
		<stop offset="1" style={{stopColor: "#3E5A83"}} />
	</linearGradient>
	<path fill={`url(#${id}_3_)`} stroke="#808080" strokeWidth="0.5" strokeMiterlimit="10" d="M4.509,96.83h65.266v8.904H4.509V96.83   z" />
	<path fill="#6D6E71" d="M6.763,99.084H67.52v6.65H6.763V99.084z" />
	<path fill="none" stroke="#194CB2" strokeWidth="0.25" d="M69.774,96.83" />
	<path fill="none" stroke="#194CB2" strokeWidth="0.25" d="M69.774,0.002" />
	<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="4.5085" y1="31.4512" x2="69.7742" y2="31.4512">
		<stop offset="0" style={{stopColor: "#3E5A83"}} />
		<stop offset="0.02" style={{stopColor: "#4C678E"}} />
		<stop offset="0.06" style={{stopColor: "#6880A5"}} />
		<stop offset="0.11" style={{stopColor: "#7F96B8"}} />
		<stop offset="0.17" style={{stopColor: "#90A6C7"}} />
		<stop offset="0.23" style={{stopColor: "#9DB1D1"}} />
		<stop offset="0.32" style={{stopColor: "#A4B8D7"}} />
		<stop offset="0.54" style={{stopColor: "#A6BAD9"}} />
		<stop offset="0.66" style={{stopColor: "#A3B7D7"}} />
		<stop offset="0.74" style={{stopColor: "#99AECF"}} />
		<stop offset="0.82" style={{stopColor: "#89A0C1"}} />
		<stop offset="0.89" style={{stopColor: "#738BAE"}} />
		<stop offset="0.96" style={{stopColor: "#567096"}} />
		<stop offset="1" style={{stopColor: "#3E5A83"}} />
	</linearGradient>
	
		<rect x="4.509" y="11.162" fill={`url(#${id}_4_)`} stroke="#808080" strokeWidth="0.5" strokeMiterlimit="10" width="65.266" height="40.58" />
	<linearGradient id={`${id}_5_`} gradientUnits="userSpaceOnUse" x1="4.5085" y1="74.2852" x2="69.7742" y2="74.2852">
		<stop offset="0" style={{stopColor: "#3E5A83"}} />
		<stop offset="0.02" style={{stopColor: "#4C678E"}} />
		<stop offset="0.06" style={{stopColor: "#6880A5"}} />
		<stop offset="0.11" style={{stopColor: "#7F96B8"}} />
		<stop offset="0.17" style={{stopColor: "#90A6C7"}} />
		<stop offset="0.23" style={{stopColor: "#9DB1D1"}} />
		<stop offset="0.32" style={{stopColor: "#A4B8D7"}} />
		<stop offset="0.54" style={{stopColor: "#A6BAD9"}} />
		<stop offset="0.66" style={{stopColor: "#A3B7D7"}} />
		<stop offset="0.74" style={{stopColor: "#99AECF"}} />
		<stop offset="0.82" style={{stopColor: "#89A0C1"}} />
		<stop offset="0.89" style={{stopColor: "#738BAE"}} />
		<stop offset="0.96" style={{stopColor: "#567096"}} />
		<stop offset="1" style={{stopColor: "#3E5A83"}} />
	</linearGradient>
	
		<rect x="4.509" y="51.74" fill={`url(#${id}_5_)`} stroke="#808080" strokeWidth="0.5" strokeMiterlimit="10" width="65.266" height="45.09" />
	<rect x="4.432" y="51.344" fill="#6D6E71" width="65.419" height="0.793" />
</g>
<g id="Group_Nameplate">
	<path fill="#CCCCCC" d="M26.94,2.256h6.764v2.254H26.94V2.256z" />
	<path fill="#333333" d="M33.704,2.256H47.23v2.254H33.704V2.256z" />
	<path fill="none" stroke="#D9E5FF" strokeWidth="0.25" d="M47.23,2.256v2.254H26.94" />
	<path fill="none" stroke="#194CB2" strokeWidth="0.25" d="M47.358,2.256H26.94v2.384" />
</g>
    
      </g>
      <rect x="0" y="0" width="72.029" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
